import { EPreviewOffersActionType } from './types';
import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const addPreviewOffers = actionGenerator<EPreviewOffersActionType.Add, IDailyRentOfferForMobileSite[]>(
  EPreviewOffersActionType.Add,
);

export const requestPreviewOffers = actionGenerator<EPreviewOffersActionType.Request>(EPreviewOffersActionType.Request);

export const successPreviewOffers = actionGenerator<EPreviewOffersActionType.Success, IDailyRentOfferForMobileSite[]>(
  EPreviewOffersActionType.Success,
);

export const failurePreviewOffers = actionGenerator<EPreviewOffersActionType.Failure>(EPreviewOffersActionType.Failure);
